var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IOdometer',{staticClass:"iOdometer",attrs:{"value":_vm.num,"styles":_vm.styles,"format":"(.ddd),dd"}})}
var staticRenderFns = []

export { render, staticRenderFns }